import React from "react";
import Notification from "../notification/Notification";
import "../saas/SaaSUIToolkit.css";
import "./formkit.css";

/**
 * Single-page form shell (title, one card, sticky footer) for forms that do not need steps.
 * The submit button is tied to the form by `formId`, so the footer can stay outside the <form>.
 */
const FormPageLayout = ({
  title,
  subtitle,
  formId,
  submitLabel = "Save",
  submitting = false,
  loading = false,
  onCancel,
  cancelLabel = "Cancel",
  maxWidth = 1200,
  children,
}) => (
  <div className="fk-page" style={{ maxWidth }}>
    <Notification />
    <div className="fk-header">
      <h1 className="fk-title">{title}</h1>
      {subtitle && <p className="fk-subtitle">{subtitle}</p>}
    </div>

    <div className="fk-card">
      {loading ? (
        <div aria-busy="true" aria-label="Loading form">
          <div className="fk-skel" style={{ height: 24, width: "40%", marginBottom: 20 }} />
          <div className="fk-grid">
            {[0, 1, 2, 3].map((n) => (
              <div key={n} className="fk-skel" style={{ height: 62 }} />
            ))}
          </div>
        </div>
      ) : (
        <div className="fk-step-enter">{children}</div>
      )}
    </div>

    <div className="fk-footer">
      <button type="button" className="fk-btn fk-btn--ghost" onClick={onCancel} disabled={submitting}>
        {cancelLabel}
      </button>
      <button type="submit" form={formId} className="fk-btn fk-btn--primary" disabled={submitting || loading}>
        {submitting && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
        {submitting ? "Saving..." : submitLabel}
      </button>
    </div>
  </div>
);

export default FormPageLayout;
